module.exports = __webpack_public_path__ + "assets/67b76669b0cc8fce14290be6625dbe03.png";